import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import CaptchaGenStatEditDto from 'app/admin/captchagenstat/dto/CaptchaGenStatEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';
import NamedDto from 'modules/base/dto/NamedDto';

class CaptchaGenStatEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'captchaGenStatEditControl';
	}

	/**
	 * @return {Promise<CaptchaGenStatEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new CaptchaGenStatEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<CaptchaGenStatEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new CaptchaGenStatEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {CaptchaGenStatEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {CaptchaGenStatEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new CaptchaGenStatEditService();
